// extracted by mini-css-extract-plugin
export default {"label":"Input_label__byM2J","input":"Input_input__axnco","close":"Input_close__ZxFt8"};